var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "4SN077"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 469"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 344",
    d: "M20 4.998c-.028.112-.054.225-.083.336a2.628 2.628 0 0 1-.685 1.207q-4.919 4.924-9.841 9.845a.977.977 0 1 1-1.366-1.394q3.781-3.784 7.566-7.564a1.142 1.142 0 0 1 .179-.125l-3.074-3.08a.819.819 0 0 1-.106.17Q7.547 9.441 2.498 14.484a1.717 1.717 0 0 0-.541 1.326c.019.734 0 1.469 0 2.222.07 0 .133.009.2.009h2.187a1.559 1.559 0 0 0 1.088-.454.931.931 0 0 1 1.013-.208.969.969 0 0 1 .349 1.6 3.258 3.258 0 0 1-2.3 1.008c-1.171.024-2.343.011-3.514.005a.958.958 0 0 1-.969-.968c-.006-1.171-.018-2.343 0-3.514a3.288 3.288 0 0 1 .912-2.2c.07-.077.145-.15.219-.223Q7.236 6.992 13.329.895a2.8 2.8 0 0 1 1.62-.863A.173.173 0 0 0 15 .004h.664a.661.661 0 0 0 .106.037 2.554 2.554 0 0 1 1.4.708q1.047 1.034 2.081 2.081a2.52 2.52 0 0 1 .676 1.251c.019.087.046.172.069.259zm-2.834.851c.229-.229.466-.453.686-.691a.69.69 0 0 0 .006-.973q-1.007-1.035-2.041-2.042a.665.665 0 0 0-.91-.042c-.265.235-.494.512-.729.76z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 345",
    d: "M20 19.142a1.136 1.136 0 0 1-.852.827.979.979 0 0 1-.189.022H9.305a1.039 1.039 0 0 1-.974-.727 1.057 1.057 0 0 1 .332-1.152 1.124 1.124 0 0 1 .75-.247h9.462a1.057 1.057 0 0 1 1.086.78.4.4 0 0 0 .04.071z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-edit.d1cee43602346ad21a6d096bb4ab9e07.svg";